import React, { useState, useEffect, useContext } from 'react';



import { DataContext } from '../../init/getData';
import { PosCartContext } from '../../init/posCartData';

import { Col, Form, Row, DropdownButton, Dropdown, Modal, Card } from 'react-bootstrap';
import { Space, Input, Tag, Button, Spin, Tabs, message, theme, CheckBox } from 'antd';


import Loader from '../../components/loader/loader';

import Category from './items/category';
import Product from './items/product';
import Cart from './items/cart';

import LoadPosJv from './functions/loadPosJv';



function PosForm(props) {

    let { showModal, toggleModal, refFetchData, editedJv, refreshTableFunction} = props;

    const { api, userData, settingData, refProductData, devData, selectedCompany, sessionId, selectedYear, refData, categoryData, currencyData } = useContext(DataContext);
    const { tabData, setCart } = useContext(PosCartContext);

    const userRole = userData.role;
    const [loadingCounter, setLoadingCounter] = useState(0);
    const [isLoading, setIsLoading] = useState(false);
    const [isSpinning, setIsSpinning] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState("");
    const [selectedTab, setSelectedTab] = useState(0);
    const [transactions, setTransactions] = useState(0);

    const createdBy = parseInt(userData.id);
    const companyId = selectedCompany.id;
    const yearId = selectedYear.id;


    const [isPrinting, setIsPrinting] = useState(true);

    const cart = tabData[selectedTab].cart;
    const journalVoucher = tabData[selectedTab].journalVoucher;

    const subTotal = cart?.reduce((e, item) => { return e + parseFloat(item.totalPrice) }, 0);
    const jvCost = cart?.reduce((e, item) => { return e + parseFloat(item.totalCost) }, 0);


    const discountPercentage = (journalVoucher.discountPercentage);
    const totalDiscounts = parseFloat(subTotal * discountPercentage / 100);


    const jvProfit = subTotal - (jvCost + totalDiscounts);

    const totalVatAmount = cart.reduce((sum, item) => { return sum + parseFloat(item.vatAmount * item.netQuantity || 0); }, 0);

    const totalPrice = (subTotal + parseFloat(totalVatAmount)) - totalDiscounts;

    const selectedCurrency = currencyData?.find(option => option.id === journalVoucher.currencyId);


    const refItems = async () => {
        setIsLoading(true)
        await refFetchData()
        setIsLoading(false)
    }


    return (
        <Modal show={showModal} fullscreen={true}>
            <Modal.Body style={{ backgroundColor: '#f0f2f5', padding: 0 }}>
                <div
                    style={{
                        display: 'flex',
                        flexDirection: 'row',
                        height: '100vh',
                        overflowY: 'auto',
                        padding: 0,
                        userSelect: 'none',
                    }}
                >
                    {isLoading && <Loader />}

                    {!isLoading && (
                        <>
                            <Category
                                setSelectedCategory={setSelectedCategory}
                            />

                            <Product
                                selectedCategory={selectedCategory}
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                refItems={refItems}
                                selectedCurrency={selectedCurrency}
                            />

                            <Cart
                                toggleModal={toggleModal}
                                setSelectedTab={setSelectedTab}
                                selectedTab={selectedTab}
                                subTotal={subTotal}
                                jvCost={jvCost}
                                jvProfit={jvProfit}
                                totalDiscounts={totalDiscounts}
                                discountPercentage={discountPercentage}
                                totalPrice={totalPrice}
                                totalVatAmount={totalVatAmount}
                                transactions={transactions}
                                journalVoucher={journalVoucher}
                                selectedCurrency={selectedCurrency}
                                editedJv={editedJv}
                                isPrinting={isPrinting}
                                setIsPrinting={setIsPrinting}
                                refreshTableFunction={refreshTableFunction}
                            />
                        </>
                    )}

                    <LoadPosJv
                        setTransactions={setTransactions}
                        cart={cart}
                        journalVoucher={journalVoucher}
                        selectedCurrency={selectedCurrency}
                        netTotal={totalPrice}
                        totalDiscounts={totalDiscounts}
                        vat={totalVatAmount}
                    />

                </div>
            </Modal.Body>
        </Modal>


    )
}

export default PosForm;
